module.exports = __webpack_public_path__ + "media/assets/images/flags/dj-b1cf0f2514bcd9e3ae03e5553efdfa8d.svg";